import { collections } from "@/mocks/home";

export default function CollectionsSection() {
  return (
    <section id="collections" className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs font-medium uppercase tracking-[0.3em] text-primary-600">
              Collections
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              专题合集，按心情挑一段
            </h2>
            <p className="mt-3 max-w-xl font-body text-sm leading-7 text-foreground-600 md:text-base">
              不按热度堆给你，而是按场景分好。先在合集里挑一个方向，再顺着看下去。
            </p>
          </div>
          <a
            href="#latest"
            className="flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看全部合集
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {collections.map((item) => (
            <article
              key={item.id}
              className="group cursor-pointer overflow-hidden rounded-2xl border border-background-200 bg-background-50"
            >
              <div className="relative h-56 w-full overflow-hidden md:h-64">
                <img
                  src={item.image}
                  alt={`${item.tag} 专题合集 - ${item.title}`}
                  title={`糖豆视频 ${item.tag} 合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-foreground-950/10 to-transparent"></div>
                <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 font-label text-xs font-semibold text-foreground-950">
                  {item.tag}
                </span>
                <span className="absolute bottom-4 right-4 flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1 font-label text-xs text-foreground-800 backdrop-blur">
                  <i className="ri-stack-line text-sm"></i>
                  {item.count}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                  {item.title}
                </h3>
                <p className="mt-2 font-body text-sm leading-7 text-foreground-600">{item.desc}</p>
                <span className="mt-4 flex items-center gap-1.5 font-label text-sm text-primary-600">
                  进入合集
                  <i className="ri-arrow-right-line text-base transition-transform duration-300 group-hover:translate-x-1"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}